// Generated by CoffeeScript 1.12.7
module.exports = function(modConf) {
  if (typeof modConf === 'string') {
    return modConf;
  } else {
    return modConf.require;
  }
};
